const MAP_STYLE_SOURCE = 'aymericclubmed';
const MAP_STYLE_ID = 'cl1276yaa000714u6zr9yvrvz';
const MAP_STYLE_PATH = `${MAP_STYLE_SOURCE}/${MAP_STYLE_ID}`;
export const MAP_STYLE_VALUE = `mapbox://styles/${MAP_STYLE_PATH}`;
